//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const approval = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getApprovals(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/approval/get-approvals?offset=${values.offset}&limit=${values.limit}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function approvalexport(values) {
    try {
      const obj = {
        method:"POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(
        `${config.host}/cdr-panel/approval/exports`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getApprovalsHistory(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/approval/get-approvals-history?offset=${values.offset}&limit=${values.limit}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err)
    }
  }

  async function approvalsHistoryFilter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/approval/approvals-history-filter?offset=${values.offset}&limit=${values.limit}&type=${values.type}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err)
    }
  }

  async function update(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/approval/update`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function search(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/approval/search?search=${values?.search}&offset=${values?.offset}&limit=${values?.limit}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function handleExportData(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      values = JSON.stringify(values)
      let res = await fetch(
        `${config.host}/cdr-panel/approval/export?query=${values}`,
        obj
      );
      return handleResponse(res);
    }
    catch (err) {
      handleError(err)
    }
  }

  return {
    getApprovals,
    update,
    search,
    getApprovalsHistory,
    approvalsHistoryFilter,
    handleExportData,
    approvalexport
  };
};

export default approval;
